import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n, ParseHtml, RouterDOM } from "utilities/utilities";
import { BtnAddOnTableRender, BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useMemo, useRef, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { FilterFieldInterface } from "components/DataGrid/DataGridProps";
import { useLocation } from "react-router";
import { useForm } from "react-hook-form";
import { I18NextNs } from "enum/enum";
import moment from "moment";
import { renderCellFile, renderCellUpdate } from "../Ticket/fnTickit";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useReceiveTicket(isSwitch,isPermission) {

  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();

  const [nPrmUser, setNPrmUser] = useState(0);
  const [nUserType, setNUserType] = useState(0);
  const [lstOptionMuseum, setLstOptionMuseum] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [messagePopper, setMessagePopper] = useState("")
  const [isOpenFile, setisOpenFile] = useState(false)
  const [arrFile, setarrFile] = useState([])

  const [loadingTable, setLoadingTable] = useState(false);
  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
    sSortExpression: "sUpdate",
    sSortDirection: "desc",
  });

       //#region Form
       const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

  useEffect(() => {
    GetCheckEmpMuseum();
  }, [])

  useEffect(() => {
    getTable(dataRow);
    // }, [])
  }, [isSwitch])

  const GetCheckEmpMuseum = () => {
    DialogFn.BlockUI();
    AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
      let objResult = result.objResult;
      setNPrmUser(objResult.nPrmUser)
      setNUserType(objResult.nUserTypeID)
      setLstOptionMuseum(objResult.lstMuseum)
      DialogFn.UnBlockUI();
    });
  };


  const getTable = (p: PaginationInterface) => {
    DialogFn.BlockUI();
    setLoadingTable(true);
    let Param = {
      ...p,
      arrRows : [],
      sOrderTicket: formSearch.getValues("sOrderTicket") ?? "",
      nStartDate: formSearch.getValues("nStartDate") ? formSearch.getValues("nStartDate").valueOf() : null,
      nEndDate: formSearch.getValues("nEndDate") ? formSearch.getValues("nEndDate").valueOf() : null,
      arrMuseumId: formSearch.getValues("arrMuseum") ?? [],
    };
    AxiosFn.Post(`Ticket/GetTableRecieveBook`, Param, (result) => {
      setLoadingTable(false);
      let objResult = result.objResult;
      setDataRow({
        ...p,
        arrRows: objResult.lstData,
        nDataLength: objResult.nDataLength,
        nPageIndex: objResult.nPageIndex,
      });
    });
    DialogFn.UnBlockUI();
  };

  const onDelete = (arrSelect) => {
    DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
      DialogFn.BlockUI();
      setLoadingTable(true);
      AxiosFn.Post(`Ticket/OnDeleteTableRecieveBook`, { lstId: arrSelect }, () => {
        getTable(dataRow)
        DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
        DialogFn.UnBlockUI();
      });
    });
  }


  const dataColumnGettingTicket: GridColDef[] = [
    {
      ...DefaultParamCol,
      
      field: "",
      width: 60,
      headerName: "",
      type: "actions",
      hideable: false,
      sortable: false,
      flex: 0,
      renderHeader: () => {
        if (isPermission && nPrmUser === 2) {
          return (
            <BtnAddOnTableRender
              path={"/ReceiveTicketForm"}
              nPermision={nPrmUser}
            />
          );
        }
      },
      renderCell: (params) => {
        return (
          <BtnEditOnTableRender
            path={"/ReceiveTicketForm"}
            params={params}
            nPermision={isPermission ? nPrmUser : 1}
          />
        );
      },
    },
    {
      ...DefaultParamCol,
      field: "sDateReceive",
      headerName: `${I18n.SetText("Ticket.DateTicket")}`,

    },
    {
      ...DefaultParamCol,
      field: "sOrderTicket",
      headerName: `${I18n.SetText("Ticket.OrderTicket")}`,

    },
    // nPrmUser !== 0 && nUserType !== 1 && {
    {
      ...DefaultParamCol,
      field: "sMuseum",
      headerName: `${I18n.SetText("Ticket.MuseumName")}`,
      align: "left",
      flex: 3,

    },
    {
      ...DefaultParamCol,
      field: "sFileLink",
      headerName: `${I18n.SetText("Ticket.AttachedDocuments")}`,
      width: 100,
      minWidth: 100,
      flex: 0,
      sortable:false,
      renderCell: (params) => {
        return (
          <>
            {params.row.sFileLink && renderCellFile(params, handleClickFile)}
          </>
        )
      }
    },
    {
      ...DefaultParamCol,
      field: "sUpdate",
      headerName: `${I18n.SetText("Ticket.DateUpdate")}`,
      flex: 1.5,
      renderCell: (params) => {
        return (
          <>
            {renderCellUpdate(params,handleClickUpdate)}
          </>
        )
      }
    },
  ];

  const handleClickUpdate = (event, params) => {
    setAnchorEl(event.currentTarget);
    setMessagePopper(params.row.sUpdateName)
  };

  const handleClickFile = (params) => {
    setarrFile([{ sFileLink: params.row.sFileLink, sFileName: params.row.sFileName }])
    setisOpenFile(true)
  };

  const handleClearSearch = () => {
    Object.keys(formSearch.getValues()).forEach((key => {
        formSearch.setValue(key, null);
        formSearch.clearErrors(key);
    }))
    getTable(dataRow);
};


  const filterListGettingTicket: FilterFieldInterface[] = [
    {
      sTypeFilterMode: "input",
      sLabel: "เลขที่ใบสั่งซื้อ",
      sFieldName: "sOrderTicket",
      nGridLG: 4,
      nGridMD: 6,
      nGridSM: 6,
      nGridXS: 12,
    },
    {
      sTypeFilterMode: "date",
      sLabel: "ตั้งแต่วันที่",
      sFieldName: "nStartDate",
      nGridLG: 2,
      nGridMD: 2,
      nGridSM: 6,
      nGridXS: 12,
    },
    {
      sTypeFilterMode: "date",
      sLabel: "ถึงวันที่",
      sFieldName: "nEndDate",
      nGridLG: 2,
      nGridMD: 2,
      nGridSM: 6,
      nGridXS: 12,
    },
    nPrmUser !== 0 && nUserType !== 1 && {
      sTypeFilterMode: "multiselect",
      sLabel: "พิพิธภัณฑ์",
      sFieldName: "arrMuseumId",
      optionSelect: lstOptionMuseum,
      nGridLG: 4,
      nGridMD: 6,
      nGridSM: 6,
      nGridXS: 12,
    },
  ];

  return {
    dataColumnGettingTicket,
    filterListGettingTicket,
    getTable,
    onDelete,
    dataRow,
    loadingTable,
    anchorEl,
    setAnchorEl,
    messagePopper,
    isOpenFile,
    setisOpenFile,
    arrFile,
    formSearch,
    lstOptionMuseum,
    nPrmUser,
    nUserType,
    handleClearSearch
  };
}


export function useReceiveTicketForm() {


  //#region Hook
  const Router = RouterDOM();
  const AxiosFn = FnAxios()
  const DialogFn = FnDialog();
  const location = useLocation();
  // #endregion

  const objParamPath = useMemo(() => {
    const ParamId = new URLSearchParams(location.search).get("strParam");
    const ParamPrs = 2;
    return { ParamId, ParamPrs }
  }, [location.search])

  //#region State / Usememo
  const onClearAttachFile = useRef(null);
  const [isPermission, setIsPermission] = useState<boolean>(false);
  const [arrAttachmentList, setArrAttachmentList] = useState([])
  const [nUserType, setNUserType] = useState(0);
  const [isSaving, setIsSaving] = useState(false)
  const [objMuseum, setObjMuseum] = useState({
    nMuseumID: 0,
    sMuseumName: "",
  })
  const [lstMuseum, setLstMuseum] = useState([])
  const [defaultValues, setDefaultValues] = useState({
    nMuseum: null,
    sMuseum: null,
    sInCentral: null,
    sOrderBook: null,
    dRecieveTicket: null,
    lstTicket: []
  })
  // #endregion

  //#region Form
  const form = useForm({
    shouldFocusError: true,
    shouldUnregister: false,
    mode: "all",
    defaultValues: defaultValues
  });
  // #endregion

  useEffect(() => {
    GetMenuPermissionParamRoute("/SupplyTicket",AxiosFn, setIsPermission, DialogFn);
    GetCheckEmpMuseum();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    form.reset(defaultValues);
  }, [defaultValues, form])

  const GetCheckEmpMuseum = async () => {
    DialogFn.BlockUI();
    await AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, async (result) => {
      DialogFn.UnBlockUI();
      let objResult = result.objResult;
      setNUserType(objResult.nUserTypeID)
      await getOptionInitialData(objResult.nUserTypeID)
    });
  };

  const gotoBack = () => {
    Router.GoToPage("/SupplyTicket", {
      state: {
        tab: "ReceiveTicket"
      }
    })
  }

  const handleSubmitForm = () => {
    
    let lstTicket = form.getValues("lstTicket");
    let indexHasValue = lstTicket.findIndex(f=>f.isRequire === true)
    
    if(indexHasValue === -1 && !objParamPath.ParamId)
    {
      DialogFn.Warning("ต้องมีรายการรับตั๋วอย่างน้อย 1 รายการ");
      return;
    }
    DialogFn.Submit("คุณต้องการบันทึกข้อมูลหรือไม่ ?", () => {
      DialogFn.CloseSubmit();
      ReSendAPISave();
    });
  }

  const ReSendAPISave = () => {
    let objParam = {
      sIDReceive: objParamPath.ParamId,
      sIDMuseum: objMuseum.nMuseumID + "",
      sFundCost: form.getValues("sInCentral"),
      sOrderBook: form.getValues("sOrderBook"),
      nRecieveDate: form.getValues("dRecieveTicket").valueOf(),
      lstRecieveTicket: form.getValues("lstTicket"),
      lstFile: arrAttachmentList,
    };
    setIsSaving(true)
    AxiosFn.Post(`Ticket/OnSubmitRecieveBook`, objParam, () => {
      setIsSaving(false)
      DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
        gotoBack();
      });
    }, () => { 
      setIsSaving(false)
      DialogFn.Warning("ขออภัย มีข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง");
    });
  }

  const getOptionInitialData = async (nUserTypeID) => {
    DialogFn.BlockUI();
    await AxiosFn.Get(`Ticket/GetFormInitialTicketBook`, null, (result) => {
      DialogFn.UnBlockUI();
      let objResult = result.objResult;
      setLstMuseum(objResult.lstMuseum)
      setObjMuseum({
        nMuseumID: objResult.nMuseumID,
        sMuseumName: objResult.sMuseumName,
      })
      form.setValue("sMuseum", objResult.sMuseumName)
      if (nUserTypeID === 1) {
        getTypeTicketMuseum(objResult.nMuseumID, objResult.sMuseumName,moment().valueOf())
      }
    });
    if (objParamPath.ParamId) {
      DialogFn.BlockUI();
      await AxiosFn.Get(`Ticket/GetFormInfoRecieveBook`, { sReceiveID: objParamPath.ParamId }, (result) => {
        DialogFn.UnBlockUI();
        let objResult = result.objResult;
        setDefaultValues({
          nMuseum: parseInt(objResult.objRecieve.sIDMuseum),
          sMuseum: objResult.objRecieve.sMuseum,
          sInCentral: objResult.objRecieve.sFundCost,
          sOrderBook: objResult.objRecieve.sOrderBook,
          dRecieveTicket: moment(objResult.objRecieve.nRecieveDate),
          lstTicket: objResult.lstTicket
        })
        setArrAttachmentList(objResult.lstFile)
      });
    }
  };

  const getTypeTicketMuseum = (nMuseumID, sMuseumName = null,dReceive) => {
    if (!nMuseumID) {
      setObjMuseum({
        nMuseumID: 0,
        sMuseumName: "",
      })
      setDefaultValues(value => {
        return ({
          ...value,
          sInCentral: form.getValues("sInCentral"),
          sOrderBook: form.getValues("sOrderBook"),
          nMuseum : null,
          lstTicket: []
        })
      })
      return;
    }
    DialogFn.BlockUI();
    AxiosFn.Get(`Ticket/GetTypeTicket`, { nMuseumID: nMuseumID, dReceive: dReceive }, (result) => {
      DialogFn.UnBlockUI();
      setObjMuseum({
        nMuseumID: nMuseumID,
        sMuseumName: sMuseumName,
      })
      setDefaultValues(value => {
        return ({
          ...value,
          nMuseum: nMuseumID,
          sMuseum: sMuseumName,
          sInCentral: form.getValues("sInCentral"),
          sOrderBook: form.getValues("sOrderBook"),
          dRecieveTicket : dReceive != null ? moment(dReceive) : null,
          lstTicket: result
        })
      })
    });
  };



  return {
    isPermission,
    objParamPath,
    onClearAttachFile,
    arrAttachmentList,
    setArrAttachmentList,
    defaultValues,
    form,
    gotoBack,
    handleSubmitForm,
    objMuseum,
    lstMuseum,
    nUserType,
    getTypeTicketMuseum,
    isSaving,
    isView : !isPermission,
  }

}